import React from "react";

import { Button } from "antd";

export default function TypeToggle({ types, selectedType, onChange }) {
  return (
    <div className="SetFrequencyForm__TypeToggle">
      {types.map((type) => (
        <Button
          key={type}
          htmlType="button"
          className={`SetFrequencyForm__ToggleButton ${selectedType === type ? "SetFrequencyForm__ToggleButton--selected" : ""}`}
          onClick={() => onChange(type)}
        >
          {type}
        </Button>
      ))}
    </div>
  );
}
